/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { OAuth2Result, OAuth2Error } from '@veeam-vspc/models/rest';

import type { TransportRequestOptions, TransportService } from '../../../core';
import type { TokenData } from './interfaces';

export class TokenSupplier {

    protected transportService: TransportService<OAuth2Error | Error>;

    constructor(transportService: TransportService<OAuth2Error | Error>) {
        this.transportService = transportService;
    }

    token(url: string, data: TokenData, options?: Partial<TransportRequestOptions>) {
        return this.transportService.post<TokenData, OAuth2Result | OAuth2Error | Error>(url, data, { ...options, noAuth: true });
    }

}
